import { type FragmentOf, graphql, readFragment } from "gql.tada";

import { ActorContextRow, truncateId } from "./ActorContextRow";

export const WebhookCallbackActorContextTypename =
  "WebhookCallbackActorContext" as const;

export const WebhookCallbackActorContextFragment = graphql(`
  fragment WebhookCallbackActorContextFields on WebhookCallbackActorContext {
    __typename
    webhookId
    deliveryId
  }
`);

interface Props {
  data: FragmentOf<typeof WebhookCallbackActorContextFragment>;
}

export function WebhookCallbackActorContext({ data }: Props) {
  const p = readFragment(WebhookCallbackActorContextFragment, data);
  return (
    <ActorContextRow>
      webhook {truncateId(p.webhookId)} · delivery {truncateId(p.deliveryId)}
    </ActorContextRow>
  );
}
